import React, { Component } from "react";
import { CircularProgress } from "@material-ui/core";

export default class BetterCircularProgress extends Component {
    render() {
        const { loading, children, style = {} } = this.props;

        if (loading) {
            return (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", ...style }}>
                    <CircularProgress color="inherit" style={{ color: "#1e407d" }} size={50} />
                </div>
            );
        }

        return children;
    }
}
